import {IntegrationListData} from "@/lib/types/integrations.ts";
import {integrationListToForm} from "@/pages/integrations/integrations.types.ts";
import {TestIntegrationModal} from "@/pages/integrations/test/TestIntegrationModal.tsx";

type IntegrationActionTestProps = {
  integration: IntegrationListData;
  show: boolean;
  setShow: (show: boolean) => void;
  onEdit: () => void;
};

export const IntegrationActionTest = ({integration, show, setShow, onEdit}: IntegrationActionTestProps) => {
  return (
    <TestIntegrationModal
      show={show}
      hide={() => {
        setShow(false);
      }}
      integration={integrationListToForm(integration)}
      onEdit={onEdit}
    />
  );
};
